(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    var dictionary = {
      Blogs: {
        close: 'Close',
        open: 'Show all blog categories'
      }
    };
    var addToggleCategories = function addToggleCategories() {
      var categoryContainer = $('.blog-categories');
      categoryContainer.each(function () {
        var $container = $(this);
        var categoryToggler = $("<div class='blog-categories-toggle'><span class='toggle closeCategories'>".concat(dictionary.Blogs.close, "</span><span class='toggle openCategories'>").concat(dictionary.Blogs.open, "</span></div>"));
        $container.prepend(categoryToggler);
        $('.toggle', $(this)).click(function () {
          var $btn = $(this);
          if ($btn.hasClass('openCategories')) {
            $container.addClass('open');
          } else {
            $container.removeClass('open');
          }
        });
      });
    };
    var reArrangeCategories = function reArrangeCategories() {
      var columns = 3,
        container = $('.blog-categories-content-wrapper'),
        blogItem = '.blog-category',
        wrapperClass = 'blog-category-list';
      container.each(function () {
        var items_per_col = new Array(),
          items = $(this).find(blogItem),
          min_items_per_col = Math.floor(items.length / columns),
          difference = items.length - min_items_per_col * columns;
        for (var i = 0; i < columns; i++) {
          if (i < difference) {
            items_per_col[i] = min_items_per_col + 1;
          } else {
            items_per_col[i] = min_items_per_col;
          }
        }
        for (var i = 0; i < columns; i++) {
          $(this).append($('<div ></div>').addClass(wrapperClass));
          for (var j = 0; j < items_per_col[i]; j++) {
            var pointer = 0;
            for (var k = 0; k < i; k++) {
              pointer += items_per_col[k];
            }
            $(this).find(".".concat(wrapperClass)).last().append(items[j + pointer]);
          }
        }
      });
    };
    reArrangeCategories();
    DGS.Dictionary.getInstance().getTexts(dictionary, function () {
      addToggleCategories();
    });
  });
})(jQuery);